import renderAuxiliarySearch from "./renderAuxiliarySearch.jsx";

export default function () {
  window.__gcse = {
    parsetags: "onload",
    initializationCallback: googleSearchInitCallback,
  };

  let searchScript = document.createElement("script");
  searchScript.setAttribute(
    "src",
    "https://cse.google.com/cse.js?cx=002837036882717780193:zsi0dtgvzhy",
  );
  document.body.appendChild(searchScript);
}

const googleSearchInitCallback = () => {
  renderAuxiliarySearch();
};
